import UploadView from "./UploadView";

export default UploadView;
